import React, {useEffect, useState} from "react";
import {Button, Card, Spinner} from "react-bootstrap";
import {fetchGlobalSettings} from "../../http/bookAPI";
import DashboardPromotionProofs from "./DashboardPromotionProofs";

const resolveImageUrl = (image) => {
    if (!image) return "";
    if (/^(data:|https?:\/\/)/i.test(image)) return image;
    const base = String(process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
    return `${base}${image.startsWith("/") ? image : `/${image}`}`;
};

const getDashboardPromotion = (settings) => (
    settings?.dashboard_promotion ||
    settings?.promotions_config?.dashboard_promotion ||
    null
);

const looksLikeHtml = (value) => /<\/?[a-z][\s\S]*>/i.test(value);

const normalizeAdminHtml = (value) => (
    String(value || "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;/g, "&")
        .replace(/\bclassName=/g, "class=")
);

const DashboardPromotionView = ({promotion: initialPromotion, onBack}) => {
    const [promotion, setPromotion] = useState(initialPromotion || null);
    const [loading, setLoading] = useState(!initialPromotion);

    useEffect(() => {
        if (initialPromotion) return undefined;
        let canceled = false;
        (async () => {
            try {
                const data = await fetchGlobalSettings();
                if (!canceled) setPromotion(getDashboardPromotion(data));
            } finally {
                if (!canceled) setLoading(false);
            }
        })();
        return () => {
            canceled = true;
        };
    }, [initialPromotion]);

    if (loading) {
        return (
            <Card className="p-3 w-100 mt-2">
                <div className="d-flex align-items-center gap-2">
                    <Spinner size="sm" />
                    <span className="text-muted">Loading promotion...</span>
                </div>
            </Card>
        );
    }

    const title = promotion?.detail_title || promotion?.card_title || "Promotion";
    const rawBody = String(promotion?.detail_text || promotion?.card_text || "").trim();
    const body = rawBody
        .split(/\n{2,}|\r?\n/)
        .map((paragraph) => paragraph.trim())
        .filter(Boolean);
    const bodyHtml = normalizeAdminHtml(rawBody);
    const bodyHasHtml = looksLikeHtml(bodyHtml);

    return (
        <Card className="p-3 w-100 mt-2">
            <div className="mb-3 d-flex justify-content-between align-items-start">
                <h5 className="mb-0 me-3">{title}</h5>

                <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={onBack}
                    style={{ whiteSpace: "nowrap", flexShrink: 0 }}
                >
                    ← Back to Dashboard
                </Button>
            </div>
            <div className="clearfix">
                {promotion?.image && (
                    <img
                        src={resolveImageUrl(promotion.image)}
                        alt={title}
                        style={{
                            float: "left",
                            width: "20%",
                            maxWidth: "150px",
                            maxHeight: "250px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            marginRight: "20px",
                            marginBottom: "10px",
                        }}
                    />
                )}
                <div
                    className="text-muted small dashboard-promotion-body"
                    style={{lineHeight: "1.4"}}
                >
                    <style>
                        {`
            .dashboard-promotion-body p {
                margin-bottom: 0.25rem;
                   margin-top: 0.25rem;
            }

            .dashboard-promotion-body h1,
            .dashboard-promotion-body h2,
            .dashboard-promotion-body h3,
            .dashboard-promotion-body h4,
            .dashboard-promotion-body h5,
            .dashboard-promotion-body h6 {
                margin-bottom: 0.35rem;
            }
        `}
                    </style>

                    {bodyHasHtml ? (
                        <div dangerouslySetInnerHTML={{__html: bodyHtml}} />
                    ) : body.length ? body.map((paragraph, index) => (
                        <p key={index} className="mb-1 fs-6">{paragraph}</p>
                    )) : (
                        <p className="mb-0">Promotion details will appear here soon.</p>
                    )}
                </div>
            </div>
            <DashboardPromotionProofs promotion={promotion} />
        </Card>
    );
};

export default DashboardPromotionView;
